<div class="w-full">
  @if (!formValue) {
    <app-button
      class="w-full"
      [label]="buttonLabel"
      (clickEvent)="showExistingSelect()"
    ></app-button>
  }
  @if (formValue) {
    <div
      class="flex w-full"
      >
      <span class="font-bold align-self-center mx-3">
        {{ formValue ? selectedExistingName : '' }}
      </span>
      @if (formValue) {
        <app-button icon="pi-times" severity="danger" [rounded]="true" [text]="true"
          (clickEvent)="onExistingSelected(null)"
        ></app-button>
      }
    </div>
  }
</div>
<p-dialog
  header="{{ dialogHeader | translate }}"
  [(visible)]="selectExistingDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{maxWidth: '1300px', minWidth: '400px'}"
  class="dropdown-menu-visible"
  >
  <div class="mb-5"></div>
  <app-input-select-entity
    [options]="options"
    [valueKey]="valueKey"
    [nameKey]="nameKey"
    [selectLabelPrefix]="selectLabelPrefix"
    [selectButtonLabel]="selectButtonLabel"
    [cancelButtonLabel]="cancelButtonLabel"
    (entitySelectedEvent)="onExistingSelected($event)"
    (cancelEvent)="onExistingSelectCancel()"
  ></app-input-select-entity>
</p-dialog>
